import React from 'react';
import style from './style.module.scss';
import {ButtonNew} from 'components/ButtonNew';
import Icon from 'components/Icon';
import {Quantity} from './Quantity';
import cs from 'classnames';
import {IProductSnippet} from 'shared/types/productSnippet.types';
import {ToCartButton} from 'components/ProductSnippet/components/CartActions/BuyButton/ToCartButton';

type TBuyButtonProps = Pick<
    IProductSnippet['cart'],
    'onGoToCart' | 'quantity' | 'onRemoveOne' | 'onAddOne' | 'onQuantityChange' | 'isPendingQuantityChange'
>;

export const BuyButton = (props: TBuyButtonProps) => {
    const {onAddOne, onRemoveOne, onQuantityChange, isPendingQuantityChange, onGoToCart, quantity} = props;

    return 0 < quantity ? (
        <BuyButton.Counter
            onAddOne={onAddOne}
            onRemoveOne={onRemoveOne}
            onGoToCart={onGoToCart}
            isPendingQuantityChange={isPendingQuantityChange}
            quantity={quantity}
            onQuantityChange={onQuantityChange}
        />
    ) : (
        <BuyButton.AddToCart onAddOne={onAddOne} isPendingQuantityChange={isPendingQuantityChange} />
    );
};

BuyButton.AddToCart = (props: Pick<TBuyButtonProps, 'onAddOne' | 'isPendingQuantityChange'>) => {
    const {onAddOne, isPendingQuantityChange} = props;

    return (
        <ButtonNew
            isStretched={true}
            isLoading={isPendingQuantityChange}
            variants={{DT: 'medium', TB: 'small', MB: 'small'}}
            theme={'black'}
            onClick={onAddOne}
        >
            В корзину
        </ButtonNew>
    );
};

BuyButton.Counter = (props: TBuyButtonProps) => {
    const {onAddOne, onRemoveOne, onQuantityChange, onGoToCart, isPendingQuantityChange, quantity} = props;

    return (
        <div className={style.root}>
            <ToCartButton className={style.inCart} onClick={onGoToCart} />
            <div className={cs(style.counter)}>
                <button
                    type={'button'}
                    className={cs(style.counter__button, {[style.isPending]: isPendingQuantityChange})}
                    onClick={onRemoveOne}
                >
                    <Icon icon={'minus'} />
                </button>
                <div className={style.counter__quantity}>
                    <Quantity value={quantity} handleChange={onQuantityChange} isLoading={isPendingQuantityChange} />
                </div>
                <button
                    type={'button'}
                    className={cs(style.counter__button, {[style.isPending]: isPendingQuantityChange})}
                    onClick={onAddOne}
                >
                    <Icon icon={'plus'} />
                </button>
            </div>
        </div>
    );
};
